module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#youtube",
      toString: function () {
        return this.url;
      }
    }